export const NoticeQueryKeys = {
  NOTICE_LIST: "notice_list",
  NOTICE_DETAIL: "notice_detail",
};
